/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bot_Optout_TitleInputs */

const en_bot_optout_title = /** @type {(inputs: Bot_Optout_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How to refuse BystepBot`)
};

const id_bot_optout_title = /** @type {(inputs: Bot_Optout_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cara menolak BystepBot`)
};

/**
* | output |
* | --- |
* | "How to refuse BystepBot" |
*
* @param {Bot_Optout_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const bot_optout_title = /** @type {((inputs?: Bot_Optout_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bot_Optout_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_bot_optout_title(inputs)
	return en_bot_optout_title(inputs)
});